import { useState } from 'react';
import { UMButton } from '../../urbanmap/_components';
import { Modal } from '../proposition-c/ui';
import { StepTeam } from './StepTeam';
import type { TeamMember } from './types';

/** PRD US-004 — invite members after creation (variant B of the "moment de l'invitation"). */
export function InviteDialog({
  candidates, members, onClose, onSave,
}: {
  candidates: TeamMember[];
  members: TeamMember[];
  onClose: () => void;
  onSave: (members: TeamMember[]) => void;
}) {
  const [draft, setDraft] = useState<TeamMember[]>(members);

  return (
    <Modal
      title="Équipe du projet"
      onClose={onClose}
      width={620}
      footer={
        <>
          <UMButton variant="secondary" onClick={onClose}>Annuler</UMButton>
          <UMButton icon="check" onClick={() => onSave(draft)}>Enregistrer</UMButton>
        </>
      }
    >
      <StepTeam candidates={candidates} members={draft} onChange={setDraft} />
    </Modal>
  );
}
